import request from '@/utils/request';
import { fileService } from "@/api/common/file-utils";

export default {
    exportExcel: (query) => request({
        url: '/feedbacks',
        method: 'get',
        param: query
    }),
    newReportInit: (ttFeedbackId) => request({
        url: `/feedback-reports?action=init`,
        method: 'get',
        params: {
            feedbackId: ttFeedbackId
        }
    }),
    getStoreFeedbackDataScopeForPlant: () => request({
        url: `/unitOfAccountGroup/getStoreFeedbackDataScopeForPlant`,
        method: 'get',
    }),
    getDetail: (ttFeedbackId, reportId) => request({
        url: `/feedback-reports`,
        method: 'get',
        params: {
            feedbackId: ttFeedbackId,
            reportId: reportId
        }
    }),
    storeDebitIssue: (ids,data) => request({
        url: `/feedbacks/${ids}/storeDebitIssue`,
        method: 'post',
        data: data
    }),
    save: (feedbackReport) => request({
        url: `/feedback-reports`,
        method: 'post',
        data: feedbackReport
    }),
    // 单独保存描述的接口
    saveByMoveTab: (data) => request({
        url: `/feedback-reports/saveByMoveTab`,
        method: 'post',
        data: data
    }),
    delFeedbackReport: (ids) => request({
        url: `/feedback-reports?ids=${ids}`,
        method: 'delete',
    }),
    reportsList: (param) => request({
        url: `feedback-reports/list`,
        method: 'post',
        data: param
    }),
    exportReportsList: (param) => request({
        url: `feedback-reports/export`,
        method: 'post',
        fullResponse: true,
        responseType: 'blob',
        data: param
    }).then(resp => {
        fileService.respToFile(resp, '调查报告.xls');
    }),
    exportReportsPdf: (id) => request({
        url: `feedback-reports/${id}/export`,
        method: 'get',
        responseType: 'blob',
        fullResponse: true
    }).then(resp => {
        fileService.respToFile(resp);
    }),
    copyCreateFeedbackReport: (ids) => request({
        url: `/feedback-reports/${ids}/copyCreate`,
        method: 'post',
    }),
    saveDebitInfo: (ids, data) => request({
        url: `/feedbacks/${ids}/debits`,
        method: 'post',
        data: data,
    }),
    haveFinalReport: (ids) => {
        return request({
            url: `feedback-reports/${ids}/haveFinalReport`,
            method: 'post',
        })
    },
    changeLevel: (data) => {
        return request({
            url: `feedback-reports/changeLevel`,
            method: 'post',
            data: data
        })
    },
    exportExcelDebit: (param) => request({
        url: 'feedback-reports/exportDebit',
        method: 'post',
        fullResponse: true,
        responseType: 'blob',
        data: param
    }).then(resp => {
        fileService.respToFile(resp, '扣账信息.xls');
    }),
    saveFcRemark: (feedbackReport) => request({
        url: `/feedback-reports/fcRemark`,
        method: 'post',
        data: feedbackReport
    }),
    //PDF下载
    exportPDF: (data) => request({
        url: 'feedback-reports/pdf',
        method: 'post',
        fullResponse: true,
        responseType: 'blob',
        data: data
    }).then(resp => {
        fileService.respToFile(resp);
    }),
    publish: (data) => request({
        url: `/feedback-reports/publish`,
        method: 'post',
        data: data
    })
}